import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  name: string;
}

export function RemoveFollowSuccessToast(props: Props) {
  const { id } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t(
        "toasts.remove_follow_success.body",
        {
          name: props.name,
        },
      )}
      id={id}
    />
  )
}
